import Vue from 'vue';

Vue.component('tab-component', {
    data() {
        return {
            tabIndex: 0,
        };
    },

    mounted() {
        this.$nextTick(() => {
            const tablist = this.$el.querySelector('[role="tablist"]');
            if (tablist) {
                tablist.addEventListener('keydown', this.handleTablistKeydown);
                this._initDragScroll(tablist);
            }
        });
    },

    beforeDestroy() {
        const tablist = this.$el.querySelector('[role="tablist"]');
        if (tablist) {
            tablist.removeEventListener('keydown', this.handleTablistKeydown);
            this._cleanupDragScroll(tablist);
        }
    },

    methods: {
        switchTab(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
                // Focus the selected tab when switched programmatically
                this.$nextTick(() => {
                    const tabs = this.$el.querySelectorAll('[role="tab"]');
                    if (tabs && tabs[index]) {
                        tabs[index].focus();
                    }
                });
            }
        },

        handleTablistKeydown(e) {
            const tabs = Array.from(this.$el.querySelectorAll('[role="tab"]'));
            const currentIndex = tabs.findIndex(
                (tab) => tab === document.activeElement,
            );

            if (currentIndex === -1) return;

            let nextIndex;
            switch (e.key) {
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    nextIndex = (currentIndex + 1) % tabs.length;
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                    break;
                case 'Home':
                    e.preventDefault();
                    nextIndex = 0;
                    break;
                case 'End':
                    e.preventDefault();
                    nextIndex = tabs.length - 1;
                    break;
                case 'Enter':
                case ' ': // Space key
                    e.preventDefault();
                    this.switchTab(currentIndex);
                    return;
                default:
                    return;
            }

            tabs[nextIndex].focus();
        },

        changeTabContainerClass(index) {
            return index === this.tabIndex ? 'tab__container-item--active' : '';
        },

        toggleHomepageSwitcherClass(index) {
            return this.tabIndex === index
                ? 'homepage__switcher-item--active'
                : '';
        },

        _initDragScroll(el) {
            let startX = 0;
            let scrollLeft = 0;
            let isDragging = false;
            let hasDragged = false;

            const onPointerDown = (e) => {
                if (e.button !== 0) return;
                isDragging = true;
                hasDragged = false;
                startX = e.pageX;
                scrollLeft = el.scrollLeft;
                el.style.cursor = 'grabbing';
                el.style.userSelect = 'none';
            };

            const onPointerMove = (e) => {
                if (!isDragging) return;
                const delta = e.pageX - startX;
                if (Math.abs(delta) > 5) {
                    hasDragged = true;
                }
                el.scrollLeft = scrollLeft - delta;
            };

            const onPointerUp = () => {
                isDragging = false;
                el.style.cursor = '';
                el.style.userSelect = '';
            };

            // Suppress click on tab buttons when the user was dragging
            const onClickCapture = (e) => {
                if (hasDragged) {
                    e.stopPropagation();
                    hasDragged = false;
                }
            };

            el.addEventListener('pointerdown', onPointerDown);
            el.addEventListener('pointermove', onPointerMove);
            el.addEventListener('pointerup', onPointerUp);
            el.addEventListener('pointercancel', onPointerUp);
            el.addEventListener('pointerleave', onPointerUp);
            el.addEventListener('click', onClickCapture, true);

            this._dragScrollCleanup = () => {
                el.removeEventListener('pointerdown', onPointerDown);
                el.removeEventListener('pointermove', onPointerMove);
                el.removeEventListener('pointerup', onPointerUp);
                el.removeEventListener('pointercancel', onPointerUp);
                el.removeEventListener('pointerleave', onPointerUp);
                el.removeEventListener('click', onClickCapture, true);
            };
        },

        _cleanupDragScroll() {
            if (this._dragScrollCleanup) {
                this._dragScrollCleanup();
                this._dragScrollCleanup = null;
            }
        },
    },
});
